export const navigationRoutes = {
    navigateToSendCustomerLogin: '/sendtestapp/login',
    navigateToSendCustomerForgotPassword: '/sendtestapp/forgot-password',
    navigateToSendCustomerRegister: '/sendtestapp/register',
    navigateToDashboard: '/sendtestapp/dashboard',
    navigateToSendCustomerSetPassword: '/sendtestapp/set-password',
    navigateToAddNewCard: '/sendtestapp/add-new-card',
    navigateToSendCustomerOtpVerification: '/sendtestapp/otp-verification',
    navigateToSendCustomerMyCards: '/sendtestapp/my-cards',
    navigateToSendCustomerChooseFlow: '/sendtestapp/choose-flow',
    navigateToSendCustomerCardsReview: '/sendtestapp/my-cards-review',
    navigateToSendCustomerMyCardsTestResult: '/sendtestapp/my-cards-test-results/',

    //BDB screens
    navigateToSendCustomerBusinessDisbursement: '/sendtestapp/money-send/business-disbursement',
    navigateToAdminBusinessDisbursement: '/admin/money-send/business-disbursement',
    navigateToSendCustomerTestResults: '/sendtestapp/money-send/test-results',
    navigateToSendCustomerViewTestResults: '/sendtestapp/money-send/view-test-results',
    navigateToAdminViewTestResults: '/admin/money-send/view-test-results',

    // Admin Routes
    navigateToAdminLogin: '/admin/login',
    navigateToAdminForgotPassword: '/admin/forgot-password',
    navigateToAdminOtpVerification: '/admin/otp-verification',
    navigateToSetPassword: '/admin/set-password',

    navigateToUnAuthorized: '/admin/unauthorized',

    navigateToAdminHome: '/admin/main/home',
    navigateToAdminDashboard: '/admin/main/dashboard',

    navigateToApiLogsList: '/admin/main/dashboard/api-logs',
    navigateToListSystemLogs: '/admin/main/dashboard/system-logs',
    navigateToExternalApiLogsView: '/admin/main/dashboard/api-logs-view/',
    navigateToSystemApiLogsView: '/admin/main/dashboard/system-logs-view/',
    navigateToListNotifications: '/admin/main/dashboard/notification-logs',

    navigateToRegisteredPortalManagementList: '/admin/main/user-management/registered-portal-user-management',
    navigateToRegisteredPortalManagementCreate: '/admin/main/user-management/registered-portal-user-management/create',
    navigateToRegisteredPortalManagementView: '/admin/main/user-management/registered-portal-user-management/view/',
    navigateToRegisteredPortalManagementEdit: '/admin/main/user-management/registered-portal-user-management/edit/',
    navigateToRegisteredPortalManagementPermissions: '/admin/main/user-management/registered-portal-user-management/user-permissions/',

    navigateToNVSAPICredentialsList: '/admin/main/configuration/nvs-api-credentials',
    navigateToNVSAPICredentialsCreate: '/admin/main/configuration/nvs-api-credentials/create',
    navigateToNVSAPICredentialsView: '/admin/main/configuration/nvs-api-credentials/view/',
    navigateToNVSAPICredentialsEdit: '/admin/main/configuration/nvs-api-credentials/edit/',

    navigateToPaymentTypeConfigurationList: '/admin/main/configuration/payment-type-configuration',
    navigateToPaymentTypeConfigurationCreate: '/admin/main/configuration/payment-type-configuration/create',
    navigateToPaymentTypeConfigurationView: '/admin/main/configuration/payment-type-configuration/view/',
    navigateToPaymentTypeConfigurationEdit: '/admin/main/configuration/payment-type-configuration/edit/',

    navigateToSponsorBankConfigurationList: '/admin/main/configuration/sponsor-bank-configuration',
    navigateToSponsorBankConfigurationCreate: '/admin/main/configuration/sponsor-bank-configuration/create',
    navigateToSponsorBankConfigurationView: '/admin/main/configuration/sponsor-bank-configuration/view/',
    navigateToSponsorBankConfigurationEdit: '/admin/main/configuration/sponsor-bank-configuration/edit/',

    navigateToNVSTestResults: '/admin/main/test-results/nvs-test-results',
    navigateToNVSTestResultsView: '/admin/main/test-results/nvs-test-results-view/',

    navigateToMoneySendTestResults: '/admin/main/test-results/money-send-test-results',
    navigateToMoneySendTestResultsView: '/admin/main/test-results/money-send-results-view/',

    navigateToUploadInventoryCards: '/admin/main/inventory-cards/upload-cards',
    navigateToInventoryCardsList: '/admin/main/inventory-cards/cards-list/',
    navigateToInventoryCardsView: '/admin/main/inventory-cards/view-cards/',
};
